export enum UserObjectGroupAcl {
  None = 0,
  CreateObjects = 1 << 0,
  EditObjects = 1 << 1,
  RenameObjects = 1 << 2,
  ChangeImei = 1 << 3,
  DeleteObjects = 1 << 4,
  SendCommands = 1 << 5,
  EditGroup = 1 << 6,
  ManageMembers = 1 << 7,
  ManagePermissions = 1 << 8,
  DeleteGroup = 1 << 9
}
